export interface ChainCoinDeductionValue {
    status: boolean
    coin_money?: number | string | null
    scene_list?: number[]
}

export const validateChainCoinDeductionValues = (values: ChainCoinDeductionValue, isChainCoinEnabled: boolean) => {
    if (!values.status) return ''
    if (!isChainCoinEnabled) return '请先开启连锁币获取规则'
    if (!(values.scene_list || []).length) return '请选择连锁币使用场景'
    if (!values.coin_money) return '请填写连锁币抵现比例'

    return ''
}
